import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory, articles as allArticles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

const colorMap: Record<string, string> = {
  primary: 'primary',
  secondary: 'secondary',
  accent: 'accent',
};

export default function CategorySection() {
  const [activeCategory, setActiveCategory] = useState(categories[0].slug);

  const activeCat = categories.find((c) => c.slug === activeCategory);
  let displayArticles = getArticlesByCategory(activeCategory);
  if (displayArticles.length === 0) {
    displayArticles = allArticles.slice(0, 3);
  }

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100/50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            内容分类
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            探索你感兴趣的话题
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            六大内容分类，覆盖亲密关系的方方面面，总能找到你需要的答案
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {categories.map((cat) => {
            const isActive = cat.slug === activeCategory;
            const c = colorMap[cat.color] || 'primary';
            return (
              <button
                key={cat.slug}
                onClick={() => setActiveCategory(cat.slug)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  isActive
                    ? `bg-${c}-500 text-white`
                    : `bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70`
                }`}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                {cat.name}
              </button>
            );
          })}
        </div>

        {activeCat && (
          <div className="mb-8 text-center">
            <p className="text-sm text-foreground-600">{activeCat.description}</p>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to={`/category/${activeCategory}`}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}